import React from "react"
import { PricingPrice } from "../typography"

const PriceComponent = ({ price, discount }) => {
  const discountHtml = (
    <div>
      <div className="old-price">{price}</div>
      <div className="discount">{discount}</div>
    </div>
  )

  return (
    <PricingPrice
      style={{ direction: "ltr", textAlign: "center" }}
      /* dangerouslySetInnerHTML={{ __html: !discount && price }} */
    >
      {discount && discount !== 0 ? discountHtml : price}
    </PricingPrice>
  )
}

export default PriceComponent
